<template>
    <div class="text-center">
        <div class="mb-5">
            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="generateReport" type="button">
                Get Report
            </button>
        </div>
        <div class="rounded w-full px-2 text-grey-darkest">
            <div>
                <h5>Choose report action:</h5>
                <input id="PDF" type="radio" name="PDF" value="PDF" v-model="selectedOption" checked>
                <label for="PDF"> Print to Adobe Acrobat (PDF) </label>
            </div>
        </div>
    </div>
</template>

<script>
import Mixin from './mixin';

export default {
    mixins: [Mixin],
    name: 'snappy-file-type-option',
    data() {
        return {
            selectedOption: null
        }
    },
    methods: {
        generateReport(){
            if(!this.selectedOption) return;
            this.getQueryParams();
            if (this.selectedOption === 'PDF') {
                this.uri += "&pdf=true&download=true";
                window.location = window.location.pathname + this.uri;
            } else {
                this.uri += "&excel=true";
                window.location = window.location.pathname  + '-excel' + this.uri;
            }
        }
    }
}
</script>
